import API from "../api";
import { studentPortalBase } from "./studentPortal";

export const fetchSessionStatement = async ({ from, to, childStudentId = null }) => {
  const res = await API.get(`${studentPortalBase(childStudentId)}/reports/session-statement`, {
    params: { from, to },
  });
  return res.data;
};

export const exportSessionStatementUrl = ({ from, to, format = "pdf", childStudentId = null }) =>
  `${studentPortalBase(childStudentId)}/reports/session-statement/export?from=${from}&to=${to}&format=${format}`;

export const emailSessionStatement = async ({ from, to, toEmail }) =>
  API.post("/student/reports/session-statement/email", null, {
    params: { from, to, toEmail },
  });
